import BackArrowIcon from 'assets/icons/BackArrowIcon';
import { useCommunity } from "components/CommunityContext";
import React, { useMemo } from 'react';

interface Props {
  current: number;
  total: number; 
  prev?: () => void;
}

const StepHeader: React.FC<Props> = ({ current, total, prev }) => {
  const stepWidthPercentage = useMemo(() => 100 / total, [total]);
  const currentStepsWidth = useMemo(() => stepWidthPercentage * (current + 1), [stepWidthPercentage, current]);
  const { assets } = useCommunity();
  
  return (
    <div className="step-header">
    <div className="step-header-status__container">
      <div className="step-header-controls">
        {prev && (
          <span onClick={prev} className="step-arrow-back">
            <BackArrowIcon color="var(--color-text)" />
          </span>
        )}
        <span className={`step-header-status__indicator`}>
          {current + 1} / {total}
        </span>
      </div>
      <div className="step-header-logo-wrapper">
        <div className="step-header-logo">
          <img src={assets?.logo?.icon} alt="Logo" style={{ height: assets?.logo?.height || 40 }} />
        </div>
      </div>
    </div>
  </div>
  );
};

export default StepHeader;